module.exports = __webpack_public_path__ + "static/media/1274_elements_bannerinfo.99024ef4.png";